import { handle401 } from './handle401';

export async function fetchWithAuth(url, options) {
  const response = await fetch(url, options);
  if (response.status === 401) {
    handle401();
  }
  return response;
}



// WEBPACK FOOTER //
// ./src/libs/fetchWithAuth.js